<style>
  /* Drag and Drop */
  .dnd-highlight {
    background: #ddd;
  }

  .jstree-node .node-icon {
    display: inline-block;
    position: absolute;
    margin: 1px 13px;
    opacity: 0.4;
    transition: 0.2s;
    cursor: pointer;
    float: right;
    margin-left: 13px;
  }

  .jstree-node .node-icon:hover {
    /*opacity: 1;*/
  }

  .dragging .node-icon {
    display: none;
  }
</style>

<template>
  <BModal
    id="modal-action"
    ref="modal-action"
    hide-footer="hide-footer"
    modal-class="modal-width-420"
  >
    <template slot="modal-title">
      {{ __('Adicionar Ação') }}
    </template>
    <template slot="default">
      <form method="post">
        <div class="form-group">
          <label>{{ __('Tipo') }}</label>
          <Multiselect
            label="label"
            v-model="action.type"
            :options="action_types"
            :multiple="false"
            :show-labels="false"
            :placeholder="multiSelect.placeholder"
          />
        </div>
        <div v-show="showActionOptions">
          <div
            class="form-group"
            v-if="actionHasOptions"
          >
            <div>
              <label>{{ __('Selecione') }}</label>
              <Multiselect
                :show-labels="false"
                :group-values="multiSelect.groupValue"
                v-model="action.value"
                :options="action.options"
                :multiple="false"
                group-label="name"
                :group-select="false"
                :placeholder="action.type ? action.type.placeholder : 'Selecione'"
                track-by="name"
                label="name"
                :deselectgrouplabel="multiSelect.deselectGroupLabel"
                :deselectlabel="multiSelect.deselectLabel"
                :selectgrouplabel="multiSelect.multiSelect"
                :selectlabel="multiSelect.selectLabel"
                :selectedlabel="multiSelect.selectedLabel"
              />
            </div>
          </div>
          <div
            class="form-group"
            v-if="! actionHasOptions"
          >
            <input
              class="form-control"
              type="text"
              name="action.options"
              v-model="action.value"
              :placeholder="action.options.placeholder"
              v-if="! action.textarea"
            >
            <textarea
              class="form-control"
              name="action.options"
              v-model="action.value"
              :placeholder="action.options.placeholder"
              :maxlength="action.options.maxlength"
              rows="5"
              v-else
            />
          </div>
          <div
            class="form-group"
            v-if="action.option_input"
          >
            <label v-text="action.option_input.placeholder" />
            <input
              class="form-control"
              :type="action.option_input.type"
              :placeholder="action.option_input.placeholder"
              v-model="action.option"
            >
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col-md-12">
              <label>{{ __('Executar após') }}</label>
            </div>
            <div class="col-3">
              <input
                class="form-control"
                type="number"
                min="0"
                name="delay"
                v-model="action.delay"
                required=""
              >
            </div>
            <div class="col-4">
              <select
                class="form-control"
                name="delay_type"
                v-model="action.delay_type"
              >
                <option
                  v-for="current in delayTypes"
                  :value="current.value"
                >
                  {{ current.text }}
                </option>
              </select>
            </div>
            <div class="col-md-12">
              <span class="form-text m-b-0">{{ __('Tempo em relação à ação anterior') }}</span>
            </div>
          </div>
        </div>
        <div class="modal-footer default-modal-footer">
          <button
            class="btn btn-box"
            type="submit"
            @click.prevent="save()"
            :disabled="saving"
          >
            <span v-if="! saving">{{ __('Salvar') }}</span><span v-else><i class="fa fa-circle-o-notch fa-spin" /> {{ __('Salvando') }}</span>
          </button>
        </div>
      </form>
    </template>
  </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue';
import { Confirm } from '../../services/Confirm';

const Alert = require('../../services/alert.js');

export default {
  components: {
    BModal,
  },

  mounted () {
    this.loadActions();
    this.parseActionJobs();

    this.$root.$on('bv::modal::hide', (event, modalId) => {
      if (modalId == 'modal-action-edit') {
        this.reset();
      }
    });
  },

  props: ['user', 'id', 'jobs'],

  data () {
    return {
      action_types: [],
      actions: [],
      action: {
        type: [],
        value: '',
        option: null,
        option_input: false,
        delay: 0,
        delay_type: 1,
        options: [],
        job: {
          name: '',
          placeholder: '',
        },
      },
      actionSelected: {
        job: {
          name: '',
          icon: '',
        },
        actionable: {
          name: '',
        },
      },
      optionSelected: null,
      scheduleIcon: '<i class="fa fa-clock-o f-s-15 schedule-icon"></i>',
      decisionTypes: [],
      delayTypes: [
        { text: 'minutos', value: 1 },
        { text: 'horas', value: 60 },
        { text: 'dias', value: 60 * 24 },
      ],
      actionDetails: '',
      actionSubTitle: '',
      actionDetailsProps: {
        'integration.whatsapp.send': 'value',
        'integration.waboxapp.send': 'value',
        'sms.send': 'value',
        'mail.send': 'html',
        'mail.notify_model': 'html',
      },
      decisionAction: null,
      // cardVisibility: {
      //   visible: false
      // },
      editing: false,
      loading: true,
      saving: false,
      multiSelect: {
        multiple: false,
        placeholder: 'Selecione',
        noResult: 'Nenhuma opção encontrada',
        groupValue: '',
        deselectGroupLabel: 'Deselecionar todos',
        deselectLabel: 'Deselecionar item',
        selectGroupLabel: 'Selecionar todos',
        selectLabel: 'Selecionar item',
        selectedLabel: 'Selecionado',
      },
    };
  },

  watch: {
    'action.type': {
      handler (type) {
        if (type) {
          this.loadActionTypeValues(type.value);
        }
      },
      deep: true,
    },
  },

  filters: {
    time (seconds) {
      return this.secondsToStr(seconds);
    },
  },

  computed: {
    decisionTypesFiltered (action) {
      return this.decisionTypesFilter(this.actionSelected);
    },

    actionHasOptions () {
      return this.action.options instanceof Array && this.action.options.length > 0;
    },

    showActionOptions () {
      if (this.actionHasOptions && this.action.placeholder) {
        return true;
      }

      if (this.action.options && this.action.options.placeholder) {
        return true;
      }

      return false;
    },

    actionTree (context, decision) {
      if (typeof context !== 'string' || typeof decision !== 'string') {
        context = null;
        decision = null;
      }

      // Only root context actions
      const actions = this.actions.filter((action) => (! context && ! action.parent_id)
            || (context == action.id && decision == action.decision));

      const nodes = this.getActionsTree();

      // Add icon
      nodes.push({
        id: '$add',
        text: 'Nova ação',
        type: 'root-add',
        context: 'root',
      });

      return {
        data: nodes,

        // On drop event
        onDropAnchor: function (source, target) {
          if (window.actionDropDebounce) {
            window.clearTimeout(window.actionDropDebounce);
          }

          // Dropped action
          window.actionDropDebounce = window.setTimeout(() => {
            const from = this.getActionById(source.id.replace('_anchor', ''));
            const to = this.getActionById(target.id.replace('_anchor', ''));

            if (to.id !== from.id) {
              this.change(from, to);
            }
          }, 400);
        }.bind(this),

        click: function (e, data) {
          let targetId;
          let nodeId = data.node.id;

          try {
            targetId = data.event.originalEvent.originalTarget.id; // Firefox
          } catch (err) {
            targetId = data.event.originalEvent.srcElement.id; // Safari + Chrome
          }

          // Use targetId instead of nodeId to remove actions.
          if (targetId.indexOf('$remove:action') == 0) {
            nodeId = targetId;
          }

          // Add action in root context
          if (nodeId == '$add') {
            this.actionInEdition = null;
            this.optionSelected = null;

            this.openModal('action');
            // Add decision
          } else if (nodeId.indexOf('$add:action:') == 0) {
            const actionId = nodeId.split('$add:action:')[1];

            this.actionSelected = actionId;
            this.openModal('decision');
            // Remove action
          } else if (nodeId.indexOf('$remove:action') == 0) {
            const actionId = nodeId.split('$remove:action:')[1];

            this.removeAction(actionId);
            // Add action in decision context
          } else if (nodeId.indexOf('$add:decision:action:') == 0) {
            const option = nodeId.split('$add:decision:action:')[1];

            this.optionSelected = option;
            this.actionInEdition = null;

            this.openModal('action');
          } else if (nodeId.indexOf('$remove:decision:') == 0) {
            const reference = nodeId.split('$remove:decision:')[1];

            this.removeDecision(reference);
          } else if (! isNaN(nodeId)) { // Just an action id (edit action)
            this.actionDetailsModal(nodeId);
          }

          return null;
        }.bind(this),
      };
    },
  },

  methods: {
    openModal (name) {
      this.$refs[`modal-${name}`].show();
    },

    hideModal (name) {
      this.$refs[`modal-${name}`].hide();
    },

    parseActionJobs () {
      // Format jobs and decision types
      for (const i in this.jobs) {
        const job = this.jobs[i];
        for (const j in job.decisions) {
          const decision = job.decisions[j];

          if (decision && decision.options && _.size(decision.options) > 0) {
            this.decisionTypes.push({
              id: `${i}-${j}`,
              text: decision.name,
              options: decision.options,
              action: i,
            });
          }
        }
      }

      this.action_types = _.map(this.jobs, (type, index) => ({
        label: type.name,
        value: index,
        job: type.job,
        textarea: !! type.textarea,
        deprecated: type.deprecated || false,
        placeholder: type.placeholder,
        option_input: type.option_input || false,
      }));
    },

    loadActions () {
      this.$http.get(`/automation/${this.id}/action`)
        .then(({ data }) => {
          this.actions = data;

          Bus.$emit('treeUpdated', this.actionTree);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    decisionTypesFilter (action) {
      action = this.getActionById(action);

      if (! action) {
        return [];
      }

      const job = this.jobs[action.type];

      return this.decisionTypes.filter((decision) => {
        if (! job) {
          return false;
        }

        for (const i in job.decisions) {
          if (decision.id == (`${action.type}-${i}`)) {
            return true;
          }
        }

        return false;
      });
    },

    loadActionTypeValues (type) {
      const params = { type };

      this.action.value = '';
      this.action.options = [];
      this.multiSelect.groupValue = '';

      this.$http.get('/automation/action/value', { params })
        .then(({ data }) => {
          const record = (this.action_types.filter((item) => item.value == type)[0] || this.action);

          this.action.job = record.job;
          this.action.textarea = !! record.textarea;
          this.action.placeholder = record.placeholder;
          this.action.option = null;
          this.action.option_input = record.option_input || false;
          this.action.options = data;

          if (this.actionHasOptions) {
            const filtered = this.action.options.filter((option) => option.groupOptions.length > 0);

            if (filtered.length > 0) {
              this.action.value = '';
              this.multiSelect.groupValue = 'groupOptions';
            }
          }
        })
        .catch(() => {
          window.alert('Nenhuma opção encontrada.');
        })
        .finally(() => {
          // Bus.$emit('treeUpdated', this.actionTree);
        });
    },

    save (e) {
      if (this.optionSelected) {
        // actionId : decisionType : optionIndex
        const optionSelected = this.optionSelected.split(':');
        this.action.parent_id = optionSelected[0];
        this.action.decision = {
          decision: optionSelected[1],
          option: optionSelected[2],
        };
      } else {
        this.action.parent_id = null;
        this.action.decision = null;
      }

      this.saving = true;

      const data = {
        type: this.action.type.value || this.action.type,
        value: this.actionHasOptions ? this.action.value.value : this.action.value,
        delay: this.action.delay * this.action.delay_type,
        option: this.action.option,
        parent_id: this.action.parent_id,
        decision: this.action.decision,
      };

      // Update
      if (this.actionInEdition) {
        this.$http.put(`/automation/${this.id}/action/${this.actionInEdition}`, data)
          .then(function () {
            this.reset();
            this.loadActions();
            this.hideModal('action');
            this.hideModal('action-edit');
          })
          .finally(function () {
            // Bus.$emit('treeUpdated', this.actionTree);
            this.saving = false;
          });
      } else {
        // Create
        this.$http.post(`/automation/${this.id}/action`, data)
          .then(function () {
            this.reset();
            this.loadActions();
            this.hideModal('action');
          })
          .finally(function () {
            // Bus.$emit('treeUpdated', this.actionTree);
            this.saving = false;
          });
      }
    },

    addDecision (decisionSelected) {
      const decision = _.clone(decisionSelected);
      const actions = _.clone(this.actions);

      for (const i in actions) {
        const action = actions[i];

        if (action.id == this.actionSelected) {
          action.decisions = actions[i].decisions || [];

          const equal = action.decisions.filter((item) => item.id == decision.id);

          if (! equal.length) {
            actions[i].decisions.push(decision);
          }
        }
      }

      this.actions = actions;
      this.hideModal('decision');

      Bus.$emit('treeUpdated', this.actionTree);
    },

    async removeDecision (reference) {
      if (! await Confirm(this.__('Deseja excluir esta decisão?'))) {
        return;
      }

      reference = reference.split(':');

      const decision = reference[0];
      const action = reference[1];
      const params = {
        automation_id: this.id,
        action_id: action,
        decision,
      };

      this.$http.delete('/automation/decision', params)
        .then((response) => {
          for (const i in this.actions) {
            const act = this.actions[i];

            if (act.id == action) {
              // Delete actions children in memory
              for (var j in this.actions) {
                const item = this.actions[j];
                let isChildren;
                isChildren = item.parent_id == act.id;
                isChildren = isChildren && item.decision;
                isChildren = isChildren && item.decision.decision == decision;
                isChildren && this.actions.splice(j, 1);
              }

              // Delete decisions in memory
              for (var j in act.decisions) {
                const dec = act.decisions[j];
                if (dec.id == decision) {
                  this.actions[i].decisions.splice(j, 1);
                }
              }
            }
          }

          this.actions = _.clone(this.actions); // Refresh
        }).catch((response) => {
          Alert.error(this.__('Erro ao excluir decisão'));
        })
        .finally(() => {
          Bus.$emit('treeUpdated', this.actionTree);
        });
    },

    async removeAction (id, index) {
      id *= 1;

      // Confirm
      if (! await Confirm(this.__('Deseja remover esta ação?'))) {
        return;
      }

      // Gets index
      if (! index) {
        for (const i in this.actions) {
          if ((this.actions[i].id * 1) == id) {
            index = i * 1;
            break;
          }
        }
      }

      // Remove
      this.$http.delete(`/automation/${this.id}/action/${id}`)
        .then((response) => {
          this.actions.splice(index, 1);
        })
        .finally(() => {
          Bus.$emit('treeUpdated', this.actionTree);
        });
    },

    reset () {
      this.editing = false;

      this.action.type = [];
      this.action.value = '';
      this.action.delay = 0;
      this.action.delay_type = 1;
      this.action.options = [];
    },

    // openPanel: function () {
    //   this.cardVisibility.visible = true;
    // },

    getActionsTree (context) {
      const result = [];

      for (const i in this.actions) {
        if (isNaN(i)) {
          continue;
        }

        let
          children = [];
        let action = this.actions[i];

        if (! action.job) {
          continue;
        }

        // If context is undefined, it is root
        if (context) {
          action.decision = action.decision || {};

          const actionContext = `${action.parent_id}:${action.decision.decision}:${action.decision.option}`;

          if (context !== actionContext) {
            continue;
          }
        } else if (action.parent_id) {
          continue;
        }

        // Add default children
        children = children.concat(this.getDefaultActionChildren(action));

        // Add decisions to in edition records
        if (! action.decisions) {
          action.decisions = [];

          const childrenActions = this.getChildrenActions(action);
          for (const j in childrenActions) {
            if (isNaN(j)) {
              continue;
            }

            const
              childrenAction = childrenActions[j];
            const childrenDecision = childrenAction.decision.decision;
            const decision = this.getDecisionTypeById(childrenDecision);

            this.actionSelected = action.id;
            this.addDecision(decision);
            action = this.getActionById(action.id); // Gets new action reference
          }
        }

        // Format Decisions and options
        if (action.decisions && action.decisions.length) {
          for (const j in action.decisions) {
            if (isNaN(j)) {
              continue;
            }

            const decision = action.decisions[j];
            let decisionOptions = [];

            for (const k in decision.options) {
              if (isNaN(k) || decision.options[k].deprecated) {
                continue;
              }

              const path = `${action.id}:${decision.id}:${k}`;
              const optionActions = this.getActionsTree(path);

              decisionOptions.push({
                id: `$add:decision:action:${path}`,
                text: decision.options[k].text,
                icon: decision.options[k].icon,
                type: 'option',
                children: optionActions,
                order: decision.options[k].order,
              });
            }

            decisionOptions = _.sortBy(decisionOptions, (item) => item.order || 0);

            children.push({
              id: `${decision.id}-${action.id}`,
              text: decision.text,
              type: 'question',
              children: decisionOptions.concat(this.getDefaultDecisionChildren(decision, action)),
            });
          }
        }

        // Format label
        let label = '';
        const value = action.actionable ? action.actionable.name : action.value;

        label += action.job ? action.job.name : '';
        label += `: ${this.getStrong(value)}`;
        label += this.getTextInfo(this.scheduleIcon + this.secondsToStr(action.delay)) + this.getRemoveIcon(action);

        // Return formatted data
        result.push({
          id: action.id,
          text: label,
          type: 'action',
          children,
          icon: action.job ? action.job.icon : undefined,
        });
      }

      return result;
    },

    getDefaultActionChildren (action) {
      const children = [];

      // If the action does not haves decisions avaliable, continue
      if (this.decisionTypesFilter(action.id).length) {
        children.push({
          id: `$add:action:${action.id}`,
          text: 'Adicionar decisão',
          type: 'add',
          context: action.id,
        });
      }

      return children;
    },

    getDefaultDecisionChildren (decision, action) {
      return [
        {
          id: `$remove:decision:${decision.id}:${action.id}`,
          text: 'Remover decisão',
          type: 'remove',
        },
      ];
    },

    getDecisionTypeById (id) {
      return this.decisionTypes.filter((decision) => decision.id == id).pop();
    },

    getActionById (id) {
      return this.actions.filter((action) => action.id == id).pop();
    },

    getChildrenActions (action) {
      return this.actions.filter((children) => children.parent_id == action.id);
    },

    truncate (string, length = 80) {
      if (string.length > length) {
        return `${string.substring(0, length).trim()}...`;
      }

      return string;
    },

    getStrong (string) {
      return `<strong>${this.truncate(string || '')}</strong>`;
    },

    getTextInfo (string) {
      return `<span class="text-grey">${string}</span>`;
    },

    secondsToStr (seconds) {
      if (seconds == 0) {
        return 'Imediatamente';
      }

      if (seconds >= 86400 && (seconds % 86400) == 0) {
        const days = seconds / 86400;
        return `Executar após ${days} ${days > 1 ? 'dias' : 'dia'}`;
      } if (seconds >= 3600 && (seconds % 3600) == 0) {
        const hours = seconds / 3600;
        return `Executar após ${hours} ${hours > 1 ? 'horas' : 'hora'}`;
      }
      const minutes = seconds / 60;
      return `Executar após ${minutes} ${minutes > 1 ? 'minutos' : 'minuto'}`;
    },

    secondsToField (seconds) {
      if (seconds == 0) {
        return {
          delay: 0,
          delay_type: 1,
        };
      }

      if (seconds >= 86400 && (seconds % 86400) == 0) {
        const days = seconds / 86400;
        return {
          delay: days,
          delay_type: 1440,
        };
      } if (seconds >= 3600 && (seconds % 3600) == 0) {
        const hours = seconds / 3600;
        return {
          delay: hours,
          delay_type: 60,
        };
      }
      const minutes = seconds / 60;
      return {
        delay: minutes,
        delay_type: 1,
      };
    },

    change (from, to) {
      const params = {
        from: from.id,
        to: to.id,
      };

      this.$http.put(`/automation/${this.id}/action/order`, params)
        .then((response) => {
          this.reset();
          this.loadActions();
        })
        .catch((response) => {
          window.alert(response.message);
        })
        .finally(() => {
          // Bus.$emit('treeUpdated', this.actionTree);
        });
    },

    actionDetailsModal (id) {
      this.actionSelected = this.getActionById(id);

      if (! this.actionSelected) {
        return;
      }
      // Show action only if has content to show
      const prop = this.actionDetailsProps[this.actionSelected.type];

      if (prop) {
        if (this.actionSelected.actionable && this.actionSelected.actionable[prop]) {
          this.actionDetails = this.actionSelected.actionable[prop];
          this.actionSubTitle = this.actionSelected.actionable.subject || this.actionSelected.actionable.title;

          this.$refs['modal-action-details'].show();

          return;
        }

        this.actionInEdition = id;

        this.loadActionTypeValues(this.actionSelected.type);

        this.action.value = this.actionSelected.value;

        this.$refs['modal-action-edit'].show();
      }
    },

    getRemoveIcon (action) {
      const id = `$remove:action:${action.id}`;

      return `<li id="${id}" class="text-danger node-icon"><i class="fa fa-trash-o"></i> Remover ação</li>`;
    },

    openMail (mail) {
      window.open(`/mail/${mail.value}`);
    },
  },
};
</script>
